module.exports = __webpack_public_path__ + "static/media/eraseTool.32801674.gif";